import { Group, Mesh, Vector3 } from '@anov/3d-core'
import { EWeatherType } from '../../utils/type'
import OutlineMesh from './outline'
import CloudMesh from './cloud'

class SkyMesh extends Mesh {
  outline: OutlineMesh
  cloud: CloudMesh
  group: Group

  constructor(option: { position: number[]; scale: number[] }) {
    super()

    this.group = new Group()
    this.outline = new OutlineMesh()
    this.cloud = new CloudMesh()

    this.initialize(option)
  }

  initialize(option) {
    this.group.add(this.outline)
    this.group.add(this.cloud)
    this.group.position.copy(new Vector3().fromArray(option.position))
    this.group.scale.copy(new Vector3().fromArray(option.scale))
    this.add(this.group)
  }

  /**
   * 设置时间
   * @param {number} time - 时间值
   */
  setTime(time: number) {
    this.outline.setTime(time)
    this.cloud.setTime(time)
  }

  /**
   * 设置云效果
   * @param {string} type - 效果类型
   * @param {ICloudOption} ops - 配置参数
   */
  setEffect(type: string, time: number) {
    this.setTime(time)
    const effects = {
      [EWeatherType.Sunny]: { cloudalpha: 3.0, cloudscale: 10.0, speed: 0.08, flash: 0.0 },
      [EWeatherType.Cloudy]: { cloudalpha: 1.5, cloudscale: 6.0, speed: 0.09, flash: 0.0 },
      [EWeatherType.Overcast]: { cloudalpha: 1.8, cloudscale: 4, speed: 0.08, flash: 1.0 },
      [EWeatherType.Rain]: { cloudalpha: 1.8, cloudscale: 4, speed: 0.08, flash: 1.0 },
      [EWeatherType.Rain_Thunderstorm]: { cloudalpha: 1.8, cloudscale: 4, speed: 0.08, flash: 1.0 },
      [EWeatherType.Snow]: { cloudalpha: 2.7, cloudscale: 4, speed: 0.08, flash: 0 },
      [EWeatherType.Snow_Blizzard]: { cloudalpha: 2.7, cloudscale: 4, speed: 0.08, flash: 0 },
      [EWeatherType.Sand_Dust_Calm]: { cloudalpha: 1.6, cloudscale: 6, speed: 0.1, flash: 0 },
      [EWeatherType.Foggy]: { cloudalpha: 2.0, cloudscale: 9, speed: 0.08, flash: 0.0 },
    }
    this.cloud.setEffect(type, effects[type])
  }

  update() {
    this.cloud.update()
  }

  delete() {
    this.group.remove(this.outline)
    this.group.remove(this.cloud)
    this.remove(this.group)
    this.removeFromParent()
  }
}

export default SkyMesh
